import fetchAPI from '../../fetchAPI';

export interface JobStatusResponse {
  jobId: string;
  jobType: string;
  status: 'pending' | 'running' | 'completed' | 'failed' | 'cancelled';
  currentStep?: string | null;
  startedAt?: string;
  completedAt?: string;
  errorMessage?: string;
  // sendBlockers: reasons a finished performance report must not go to the client yet
  result?: { shareUrl?: string; sendBlockers?: string[]; [key: string]: any };
}

export const callGetJobStatus = async (jobId: string): Promise<iResponse<JobStatusResponse>> => {
  const response = await fetchAPI<JobStatusResponse>({
    method: 'GET',
    route: `jobs/${jobId}`
  });
  return response;
};

export default callGetJobStatus;
